import {useEffect,useState} from 'react';
import {Link} from 'react-router-dom';
import {api} from '../lib/api.js';

export default function UploadsList({teams,initialTeamId,onClose}){
  const [team,setTeam]=useState(()=>teams.some((t)=>t.id===initialTeamId)?initialTeamId:'all');
  const [uploads,setUploads]=useState(null),[error,setError]=useState(null);
  useEffect(()=>{
    let live=true,timer;
    const refresh=async()=>{
      if(document.hidden){timer=setTimeout(refresh,5000);return;}
      try{
        const groups=await Promise.all(teams.filter((t)=>team==='all'||t.id===team).map(async(t)=>{
          const r=await api(`/supply-chain/teams/${t.id}/imports`);
          return r.imports.map((u)=>({...u,teamId:t.id,teamName:t.name}));
        }));
        if(live){setUploads(groups.flat().sort((a,b)=>Date.parse(b.created_at)-Date.parse(a.created_at)));setError(null);}
      }catch(e){if(live)setError(e.message);}
      if(live)timer=setTimeout(refresh,5000);
    };
    setUploads(null);refresh();return()=>{live=false;clearTimeout(timer);};
  },[teams,team]);
  return <section aria-label="Upload history">
    <button className="btn-link" onClick={onClose}>← Back to sites</button>
    <h2>Your uploads</h2>
    <p>Uploads stay here while review or route generation is in progress. You can leave this page and return later.</p>
    {teams.length>1&&<label>Team<select value={team} onChange={(e)=>setTeam(e.target.value)}><option value="all">All teams</option>{teams.map((t)=><option key={t.id} value={t.id}>{t.name}</option>)}</select></label>}
    {error&&<p className="banner err" role="alert">{error}</p>}
    {!uploads&&!error&&<p>Loading uploads…</p>}
    {uploads?.length===0&&<p>No uploads yet.</p>}
    <ul className="route-list">{uploads?.map((u)=>{
      const state=u.processing_routes>0?'Generating routes':u.failed_routes>0?'Routes need attention':u.status==='review'?'Awaiting review':u.status==='completed'?'Complete':u.status;
      return <li key={u.id} className="form-card">
        <strong>{u.filename}</strong><span>{state} · {u.teamName}</span>
        <span>{u.record_count} records · {u.ready_routes} routes ready · {u.processing_routes} routes processing · {u.failed_routes} routes failed</span>
        {u.needs_review>0&&<span>{u.needs_review} records awaiting a decision</span>}
        {u.error&&<span role="alert">{u.error}</span>}
        <Link className="btn" to={`/sites?upload=1&team=${encodeURIComponent(u.teamId)}&import=${encodeURIComponent(u.id)}`}>{u.status==='review'?'Continue review':'View upload progress'}</Link>
      </li>;
    })}</ul>
  </section>;
}
